import React from "react";
import { SelectInput } from "react-admin";

const choices = [
	{ id: -1, name: "NO" },
	{ id: 1, name: "YES" },
	{ id: 0, name: "PROBABLY" },
];

export const YesNoINoneInput = (props) => {
	return (
		<SelectInput
			{...props}
			choices={choices}
		/>
	);
};
